import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { InformacionEmpresaRepository } from 'src/app/domain/service/informacion-empresa/informacion-empresa-repository';
import {
  InformacionEmpresaEjecDetalle,
  InformacionEmpresaEjecDetalleFiltro,
  InformacionEmpresaEjec,
  InformacionEmpresaEjecFiltro,
  InformacionEmpresaHg,
  InformacionEmpresaHgFiltro,
  InformacionEmpresaInf,
  InformacionEmpresaInfDetalle,
  InformacionEmpresaInfDetalleFiltro,
  InformacionEmpresaInfFiltro,
  InformacionEmpresaOc,
  InformacionEmpresaOcDetalle,
  InformacionEmpresaOcDetalleFiltro,
  InformacionEmpresaOcFiltro,
  InformacionEmpresaProg,
  InformacionEmpresaProgDetalle,
  InformacionEmpresaProgDetalleFiltro,
  InformacionEmpresaProgFiltro
} from 'src/app/domain/model/informacion-empresa/informacion-empresa-oc';
import { Catalogo, CatalogoOption } from 'src/app/domain/model/catalogo/catalogo';

@Injectable({ providedIn: 'root' })
export class HttpInformacionEmpresaRepository extends InformacionEmpresaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/informacion-empresa`;

  listarOrdenadoConsultoria(filtro: InformacionEmpresaOcFiltro): Promise<InformacionEmpresaOc[]> {
    let params = new HttpParams();

    if (filtro.inuano != null) params = params.set('inuano', String(filtro.inuano));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 100));

    return firstValueFrom(
      this.http.get<InformacionEmpresaOc[]>(`${this.baseUrl}/ordenado-consultoria`, { params })
    );
  }

  listarDetalleOrdenadoConsultoria(filtro: InformacionEmpresaOcDetalleFiltro): Promise<InformacionEmpresaOcDetalle[]> {
    let params = new HttpParams();

    if (filtro.inutarea != null) params = params.set('inutarea', String(filtro.inutarea));
    if (filtro.inuclasificacion != null) params = params.set('inuclasificacion', String(filtro.inuclasificacion));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaOcDetalle[]>(`${this.baseUrl}/detalle-ordenado-consultoria`, { params })
    );
  }

  listarHistorialGestiones(filtro: InformacionEmpresaHgFiltro): Promise<InformacionEmpresaHg[]> {
    let params = new HttpParams();

    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.idafeini) params = params.set('idafeini', filtro.idafeini);
    if (filtro.idafefin) params = params.set('idafefin', filtro.idafefin);

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaHg[]>(`${this.baseUrl}/historial-gestiones`, { params })
    );
  }

  listarCitasProgramadas(filtro: InformacionEmpresaProgFiltro): Promise<InformacionEmpresaProg[]> {
    let params = new HttpParams();

    if (filtro.inuano != null) params = params.set('inuano', String(filtro.inuano));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaProg[]>(`${this.baseUrl}/citas-programadas`, { params })
    );
  }

  listarServiciosEntregados(filtro: InformacionEmpresaEjecFiltro): Promise<InformacionEmpresaEjec[]> {
    let params = new HttpParams();

    if (filtro.inuano != null) params = params.set('inuano', String(filtro.inuano));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuCumplimiento != null) params = params.set('inuCumplimiento', String(filtro.inuCumplimiento));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaEjec[]>(`${this.baseUrl}/servicios-entregados`, { params })
    );
  }

  listarInformesEntregados(filtro: InformacionEmpresaInfFiltro): Promise<InformacionEmpresaInf[]> {
    let params = new HttpParams();

    if (filtro.inuano != null) params = params.set('inuano', String(filtro.inuano));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuCumplimiento != null) params = params.set('inuCumplimiento', String(filtro.inuCumplimiento));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaInf[]>(`${this.baseUrl}/informes-entregados`, { params })
    );
  }

  listarDetalleInformesEntregados(filtro: InformacionEmpresaInfDetalleFiltro): Promise<InformacionEmpresaInfDetalle[]> {
    let params = new HttpParams();

    if (filtro.inutarea != null) params = params.set('inutarea', String(filtro.inutarea));
    if (filtro.inuclasificacion != null) params = params.set('inuclasificacion', String(filtro.inuclasificacion));
    if (filtro.inutipocita != null) params = params.set('inutipocita', String(filtro.inutipocita));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.idafeini) params = params.set('idafeini', filtro.idafeini);
    if (filtro.idafefin) params = params.set('idafefin', filtro.idafefin);
    if (filtro.inuCumplimiento != null) params = params.set('inuCumplimiento', String(filtro.inuCumplimiento));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaInfDetalle[]>(`${this.baseUrl}/informes-entregados/detalle`, { params })
    );
  }

  listarDetalleServiciosEntregados(filtro: InformacionEmpresaEjecDetalleFiltro): Promise<InformacionEmpresaEjecDetalle[]> {
    let params = new HttpParams();

    if (filtro.inutarea != null) params = params.set('inutarea', String(filtro.inutarea));
    if (filtro.inuclasificacion != null) params = params.set('inuclasificacion', String(filtro.inuclasificacion));
    if (filtro.inutipocita != null) params = params.set('inutipocita', String(filtro.inutipocita));
    if (filtro.inuestado_cita != null) params = params.set('inuestado_cita', String(filtro.inuestado_cita));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.idafeini) params = params.set('idafeini', filtro.idafeini);
    if (filtro.idafefin) params = params.set('idafefin', filtro.idafefin);
    if (filtro.inuCumplimiento != null) params = params.set('inuCumplimiento', String(filtro.inuCumplimiento));

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaEjecDetalle[]>(`${this.baseUrl}/servicios-entregados/detalle`, { params })
    );
  }

  listarDetalleCitasProgramadas(filtro: InformacionEmpresaProgDetalleFiltro): Promise<InformacionEmpresaProgDetalle[]> {
    let params = new HttpParams();

    if (filtro.inutarea != null) params = params.set('inutarea', String(filtro.inutarea));
    if (filtro.inuclasificacion != null) params = params.set('inuclasificacion', String(filtro.inuclasificacion));
    if (filtro.inutipocita != null) params = params.set('inutipocita', String(filtro.inutipocita));
    if (filtro.inuestadocita != null) params = params.set('inuestadocita', String(filtro.inuestadocita));
    if (filtro.inuasesor != null) params = params.set('inuasesor', String(filtro.inuasesor));
    if (filtro.inuoficina != null) params = params.set('inuoficina', String(filtro.inuoficina));
    if (filtro.inucentrotrabajo != null) params = params.set('inucentrotrabajo', String(filtro.inucentrotrabajo));
    if (filtro.inubeneficiario != null) params = params.set('inubeneficiario', String(filtro.inubeneficiario));
    if (filtro.inuproducto != null) params = params.set('inuproducto', String(filtro.inuproducto));
    if (filtro.idafeini) params = params.set('idafeini', filtro.idafeini);
    if (filtro.idafefin) params = params.set('idafefin', filtro.idafefin);

    params = params.set('inudesde', String(filtro.inudesde ?? 1));
    params = params.set('inuhasta', String(filtro.inuhasta ?? 10));

    return firstValueFrom(
      this.http.get<InformacionEmpresaProgDetalle[]>(`${this.baseUrl}/citas-programadas/detalle`, { params })
    );
  }

  async listarTiposCitaServicio(): Promise<CatalogoOption[]> {
    const response = await firstValueFrom(
      this.http.get<Catalogo[]>(`${this.baseUrl}/citas-programadas/tipos-cita`)
    );
    return (response || []).map((item) => ({
      codigo: item.codigo,
      descripcion: item.descripcion
    }));
  }

  async listarEstadosCitaProgramadas(): Promise<CatalogoOption[]> {
    const response = await firstValueFrom(
      this.http.get<Catalogo[]>(`${this.baseUrl}/citas-programadas/estados-cita`)
    );
    return (response || []).map((item) => ({
      codigo: item.codigo,
      descripcion: item.descripcion
    }));
  }
}
